"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Rules the web and mobile template editors share: who a template can be
 * shared with, the client-side checks (the server repeats them) and the
 * message shown when saving fails. */


var _log = require('shared/log');
var _templateRenderer = require('./templateRenderer');

 const MAX_TEMPLATE_NAME = 100; exports.MAX_TEMPLATE_NAME = MAX_TEMPLATE_NAME
 const MAX_TEMPLATE_BODY = 40000; exports.MAX_TEMPLATE_BODY = MAX_TEMPLATE_BODY

/* A "Who can use it" choice: 'private', 'org', or 'team:<TeamKey>'. */


 const scopeChoiceOf = (t) =>
  t.Scope === 'team' && t.TeamKey ? `team:${t.TeamKey}` : t.Scope === 'org' ? 'org' : 'private'; exports.scopeChoiceOf = scopeChoiceOf

 const scopeFromChoice = (choice) =>
  choice.startsWith('team:')
    ? { Scope: 'team', TeamKey: choice.slice('team:'.length)  }
    : { Scope: choice  }; exports.scopeFromChoice = scopeFromChoice

/* What the server lets me share into: myself, each team I manage templates
 * for, and (anyone) the whole org. */
 const templateScopeOptions = (teams, orgName) => [
  { value: 'private' , label: 'Only me' },
  ...teams.map(t => ({ value: `team:${t.TeamKey}` , label: t.Name })),
  { value: 'org' , label: `Everyone at ${orgName}` },
]; exports.templateScopeOptions = templateScopeOptions

/* The line under "Who can use it": shared means everyone it's shared with
 * can use and edit it. */
 const scopeHint = (choice, teams, orgName) => {
  if (choice === 'private') return 'Only you can use it.'
  if (choice === 'org') return `Everyone at ${orgName} can use and edit it.`
  const team = teams.find(t => `team:${t.TeamKey}` === choice)
  return `Everyone on ${_nullishCoalesce(_optionalChain([team, 'optionalAccess', _ => _.Name]), () => ( 'the team'))} can use and edit it.`
}; exports.scopeHint = scopeHint

/* A variable name the editor may insert, checked as a whole: lowercase
 * letters, digits and "_", at most MAX_VARIABLE_NAME long, the rule Save
 * applies to every token. */
 const isVariableName = (name) =>
  !!name && /^[a-z0-9_]+$/.test(name) && name.length <= _templateRenderer.MAX_VARIABLE_NAME; exports.isVariableName = isVariableName

/* A custom name as the editor inserts it, standardized ("Appt Date" →
 * "appt_date"), or null when standardizing can't make it a variable name. */
 const insertableVariableName = (name) => {
  const normalized = _templateRenderer.normalizeVariableName.call(void 0, _nullishCoalesce(name, () => ( '')))
  return exports.isVariableName.call(void 0, normalized) ? normalized : null
}; exports.insertableVariableName = insertableVariableName

/* Client-side checks on the body as it will be saved (normalizeBody: case and
 * spacing in variable names are standardized, never refused); the server
 * repeats them. */
 const validateTemplate = (name, body) => {
  if (!name.trim()) return 'Give the template a name.'
  if (_templateRenderer.renderLength.call(void 0, name.trim()) > exports.MAX_TEMPLATE_NAME) return `A name can be at most ${exports.MAX_TEMPLATE_NAME} characters.`
  if (!body.trim()) return 'Write the message.'
  const saved = _templateRenderer.normalizeBody.call(void 0, body)
  if (_templateRenderer.renderLength.call(void 0, saved) > exports.MAX_TEMPLATE_BODY) return `A message can be at most ${exports.MAX_TEMPLATE_BODY.toLocaleString()} characters.`
  const invalid = _templateRenderer.invalidTokenNames.call(void 0, saved)
  if (invalid.length === 0) return null
  if (invalid[0] === '') return 'A variable needs a name between {{ and }}.'
  if (_templateRenderer.renderLength.call(void 0, invalid[0]) > _templateRenderer.MAX_VARIABLE_NAME) return `A variable name can be at most ${_templateRenderer.MAX_VARIABLE_NAME} characters: {{${invalid[0]}}}`
  return `Variable names can use only letters, numbers and underscores: {{${invalid[0]}}}`
}; exports.validateTemplate = validateTemplate

 const saveErrorMessage = (e) => {
  if (e instanceof _log.CommandError && e.Error === 'unauthorized command') {
    return "You don't have permission to change this template."
  }
  if (e instanceof _log.CommandError && typeof e.Error === 'string' && e.Error.length < 200) return e.Error
  return 'Something went wrong. Please try again.'
}; exports.saveErrorMessage = saveErrorMessage
